// French dictionary. Same keys as en.ts. Machine-assisted, reviewed for tokens.

export const fr: Record<string, string> = {
  "dawn.era0": "La steppe ouverte",
  "dawn.era1": "Les khagans",
  "dawn.era2": "Pierre et empire",
  "dawn.era3": "La république",
  "dawn.era4": "Au-delà du ciel",
  "dawn.lore0": "Le ciel bleu éternel couvre les premières tentes.",
  "dawn.lore1": "La bannière du loup se lève vers le Ciel.",
  "dawn.lore2": "De Manzikert, tu gagnes le cœur de l’Anatolie.",
  "dawn.lore3": "Tes coupoles répondent au Ciel.",
  "dawn.lore4": "Des cendres naît un peuple.",
  "dawn.lore5": "Le Ciel cesse d’être un toit et devient une porte.",
  "dawn.lore6": "Sous des cieux étrangers, tu dresses ta tente.",
  "dawn.lore7": "Tu es désormais le berger des étoiles.",
  "dawn.lore8": "La Voie lactée devient ta route de migration.",
  "dawn.lore9": "Tu lis la première lumière de l’univers.",
  "dawn.lore10": "Le dernier voile se lève.",
  "dawn.lore11": "Le cercle se referme; le premier matin t’attend.",
  'common.continue': 'Continuer',
  'common.skip': 'Passer',
  'common.next': 'Suivant',
  'common.finish': 'Terminé',
  'common.close': 'Fermer',
  'common.back': 'Retour',
  'common.send': 'Envoyer',
  'common.begin': 'Commencer',

  'hud.spoils': 'Butin',
  'hud.skillPts': 'Pts compét.',
  'hud.cosmic': 'Cosmique',
  'hud.population': 'Population',
  'hud.buildings': 'Bâtiments',
  'hud.autoOn': 'Récolte auto : activée',
  'hud.autoProgress': 'Récolte auto : {have}/{need} récolteurs',
  'hud.nextBuilding': 'Prochain bâtiment',
  'hud.needPop': "augmentez d'abord la population",
  'hud.ascend': 'Ascension',

  'wave.next': 'Vague suivante',
  'wave.waveN': 'Vague {n}',
  'wave.bossN': 'Vague de boss ({n})',
  'wave.incoming': 'Vague imminente',
  'wave.bossIncoming': 'Boss imminent',
  'wave.now': 'MAINTENANT',
  'wave.yourPower': 'Votre puissance',
  'wave.enemyPower': 'Puissance ennemie',
  'wave.conquer': 'Conquête de {planet} : ère {goal}',
  'wave.conquered': '{planet} conquise',

  // porte d'ère (le boss qui verrouille chaque passage d'ère)
  'gate.progress': '{boss} se rassemble à la porte : {pct}%',
  'gate.atGate': '{boss} à la porte !',
  'gate.final': 'Dernière ère atteinte',
  'gate.summonTitle': 'La porte s\'ouvre',
  'gate.summonSub': '{boss} se masse à la porte. Bats-le pour entrer dans le prochain âge ; s\'il perce, ta lignée tombe.',
  'gate.freeProgress': 'Prochain âge : {pct}%',
  'gate.cleared': 'Porte brisée',
  'gate.clearedSub': 'Une nouvelle ère t\'attend',

  'banner.repelled': 'Vague repoussée',
  'banner.overrun': "Village pris d'assaut",
  'banner.onHorizon': "{enemy} à l'horizon",
  'banner.bossApproaches': 'Le boss marche sur la porte',
  'banner.scattered': '{enemy} dispersés',
  'banner.brokeThrough': '{enemy} a percé',

  'milestone.autoTitle': 'Récolte automatique débloquée',
  'milestone.autoSub': 'Votre peuple récolte désormais les ressources tout seul.',
  'milestone.settlementNow': 'Votre campement est désormais un {name}',
  'milestone.settlementGrows': "Votre campement s'agrandit",

  'intro.begin': 'Commencer',
  'intro.tagline': 'De la poussière de la steppe à la maîtrise du ciel.',
  'intro.story':
    "Sous le ciel bleu éternel, une poignée de tentes sur la steppe. Vous ne gouvernez pas le peuple ; vous êtes la volonté du ciel qui le guide. Élevez-vous d'âge en âge, renaissez plus fort de vos cendres quand vous tombez, et ouvrez-vous aux étoiles jusqu'à ce que le ciel ne soit plus un plafond mais une patrie où revenir.",

  'news.title': 'Nouveautés',
  'news.sub': 'Ce qui a changé depuis votre dernière visite (v{version})',
  'news.all': 'Toutes les nouveautés',

  'tut.s1.title': 'Bienvenue',
  'tut.s1.text':
    "Voici votre peuple. Touchez là où vous voulez récolter ; le cercle jaune s'y installe et exploite les arbres, rochers et minerais autour. Touchez ailleurs pour le déplacer (sur ordinateur il suit la souris).",
  'tut.s2.title': 'Ressources',
  'tut.s2.text': "Le bois, la pierre, le minerai et le savoir que vous récoltez s'accumulent ici.",
  'tut.s3.title': 'Votre campement',
  'tut.s3.text':
    "Votre peuple construit tout seul avec ces ressources. La population, le nombre de bâtiments et ce qu'il faut pour le prochain s'affichent ici.",
  'tut.s4.title': 'Vagues',
  'tut.s4.text':
    'Des pillards surgissent par intervalles. Si votre puissance suffit, vous les repoussez ; si une vague perce, votre lignée tombe et vous renaissez avec sagesse.',
  'tut.s5.title': 'Le reste vous appartient',
  'tut.s5.text':
    'Chaque âge suivant est gardé par un boss à la porte : battez-le pour gagner un artéfact et choisir une voie (économie, armée, savoir). 🔬 technologie, 👤 compte et retours. Amusez-vous bien !',

  'account.title': 'Compte',
  'account.feedbackLabel': 'Retours',
  'account.feedbackPlaceholder': 'Votre avis ? Bug, idée, ressenti... tout aide.',
  'account.dangerZone': 'Zone sensible',
  'account.resetBtn': 'Effacer toute la progression (recommencer)',
  'account.resetConfirm':
    "Êtes-vous sûr ? L'arbre de compétences, le cosmique, les planètes et la partie en cours seront tous effacés. Action irréversible.",
  'account.resetYes': 'Oui, tout effacer',
  'account.resetNo': 'Annuler',
  'account.replayTutorial': 'Revoir le guide',
  'account.logout': 'Se déconnecter',
  'account.signIn': 'Se connecter pour sauvegarder ma progression',
  'account.guest': 'Vous jouez en invité. Votre progression reste sur cet appareil.',
  'account.language': 'Langue',
  'account.supportLabel': 'Soutien',
  'account.supportBtn': 'Soutenir ce jeu',

  'nudge.early': 'Ça se passe comment ? Un petit mot aide beaucoup 🙏',
  'nudge.later': 'Déjà arrivé jusqu\'ici ! Envie de partager votre avis ?',
  'nudge.cta': 'Retours',

  'login.title': 'Connexion',
  'login.sub':
    'Connectez-vous pour conserver votre progression sur tous vos appareils. Vous pouvez passer et vous connecter plus tard via 👤.',
  'login.guest': 'Jouer maintenant, se connecter plus tard',
  'login.emailPlaceholder': 'votre@email.com',
  'login.sendCode': 'Envoyer le code',
  'login.codePlaceholder': 'Code à 6 chiffres',
  'login.verify': 'Vérifier',
  'login.sending': 'Envoi...',
  'login.codeSent': 'Un code a été envoyé à votre e-mail.',
  'login.verifying': 'Vérification...',
  'login.errGeneric': 'Une erreur est survenue, réessayez.',
  'login.errCode': 'Le code est incorrect ou expiré.',

  'death.title': 'Votre lignée est tombée',
  'death.lede':
    "Vous avez atteint l'Âge {age}. Vagues tenues : {waves}. Dépensez votre sagesse durement acquise, puis relevez-vous.",
  'death.bossLede':
    "Le boss d'ère {boss} a brisé votre porte à l'Âge {age}. Vagues tenues : {waves}. Mettez vos nouveaux points en défense avant de l'affronter à nouveau.",
  'death.wavesHeld': 'Vagues tenues',
  'death.ageReached': 'Âge atteint',
  'death.skillPoints': 'Points de compétence',
  'death.restart': 'Renaître',
  'death.ascendTo': '🚀 Ascension vers {planet} (+{gain} cosmique)',

  'offline.title': 'Pendant votre absence',
  'offline.sub': 'Votre peuple a continué de travailler pendant {time}.',
  'offline.collect': 'Récupérer',

  'cards.title': "Un âge s'achève",
  'cards.sub': 'Choisissez une voie pour votre peuple.',

  'cat.economy': 'Économie',
  'cat.military': 'Militaire',
  'cat.knowledge': 'Savoir',
  'lab.active': 'Actif',
  'lab.cost': 'Coût',
  'lab.title': 'Laboratoire',
  'lab.spoilsWord': 'Butin',
  'lab.techs': 'Technologies (butin)',
  'lab.artifacts': 'Artéfacts (activer avec des ressources)',
  'lab.artifactsHint': "Battez le boss d'ère à chaque porte d'âge pour récupérer son artéfact.",

  'err.invalid_email': 'Saisissez un e-mail valide.',
  'err.send_failed': "Impossible d'envoyer le code, réessayez bientôt.",
  'err.missing_fields': 'Informations manquantes.',
  'err.need_code': "Demandez d'abord un code.",
  'err.too_many_attempts': 'Trop de tentatives. Demandez un nouveau code.',
  'err.code_expired': 'Le code a expiré.',
  'err.code_wrong': 'Le code est incorrect.',
  'err.invalid_save': 'Sauvegarde invalide.',
  'err.empty_feedback': 'Le retour est vide.',
  'err.auth_required': 'Connexion requise.',
  'account.feedbackEmpty': "Écrivez d'abord quelque chose.",
  'account.feedbackThanks': 'Merci, envoyé !',
  'account.feedbackError': "Échec de l'envoi, réessayez.",
  'account.btnTitle': 'Compte et retours',
  'milestone.ageDawns': "L'Âge {n} se lève",
  'milestone.synergy': 'Synergie : {name}',
  'milestone.artifactFound': 'Artéfact trouvé : {name}',
  'milestone.artifactHint': 'Activez-le avec des ressources',
  'milestone.artifactActive': '{name} activé',
  'milestone.conquerReady': '{planet} est à vous',
  'milestone.conquerReadySub': 'Montez pour engranger le pouvoir cosmique et prendre le monde suivant',
  'milestone.ascended': 'Ascension vers {planet}',
  'milestone.ascendedSub': '+{gain} de pouvoir cosmique',
  'combat.dodge': 'Esquive !',
  'combat.miss': 'Raté',
  'combat.block': 'Bloqué',
  'lab.owned': 'Acquis',
  'lab.activate': 'Activer',
  'ui.soundTitle': 'Son on/off',
  'login.signedIn': 'connecté',
  'login.offline': 'hors ligne',
  'skill.lv': 'Nv {lvl}/{max}',
  'skill.max': 'MAX',
  'offline.nothing': "Rien n'a été récolté en votre absence.",
  'death.firstLede': "Ce n'est pas la fin, c'est la boucle : chaque chute paie en sagesse. Dépensez-la et relevez-vous plus fort.",
  'death.spendHint': 'Dépensez vos points, puis relevez-vous.',
  'err.google_failed': 'Échec de la connexion Google.',
  'login.or': 'ou',

  // Wave skip + voluntary retirement (v0.10)
  'wave.sendNow': 'Lancer la vague maintenant',
  'retire.btn': 'Terminer la civilisation',
  'retire.lockedAt': 'Se débloque à l\'Ère {n}',
  'retire.confirm': 'Retouchez pour terminer',
  'death.retireLede': 'Vous avez clos cette lignée de votre propre chef : Ère {age}, {waves} vagues tenues. Dépensez la sagesse, puis fondez-en une plus forte.',
};
